import React, { useState, useEffect } from 'react';
import { getMembers } from '@/lib/data';

export function MobileMembersTest() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        console.log('Loading members...');
        
        const membersData = await getMembers();
        console.log('Members loaded:', membersData);
        setMembers(membersData || []);
      } catch (err) {
        console.error('Error loading members:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return <div>Loading members...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <h1>Mobile Members Test</h1>
      <p>Members count: {members.length}</p>
      <pre>{JSON.stringify(members.slice(0, 3), null, 2)}</pre>
    </div>
  );
}